import { render } from "./UserAddHeader.vue?vue&type=template&id=3724b310"
import script from "./UserAddHeader.vue?vue&type=script&lang=js"
export * from "./UserAddHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__